<script setup>
import { reactive } from 'vue';
import ThermActivitiesItem from '~/common/components/organisms/hawk-activities/therm-activities-item.vue';
import { useCommonImports } from '~/common/composables/common-imports.composable.js';

const props = defineProps({
  defectUid: {
    type: String,
    required: true,
  },
});

const { $date, $services } = useCommonImports();

const state = reactive({
  is_loading: false,
  activities: [],
});

async function getActivities() {
  try {
    state.is_loading = true;
    const { data } = await $services.common.get_activities({
      module: 'therm',
      resource_type: 'defect',
      resource_uid: props.defectUid,
    });
    state.activities = data;
    state.is_loading = false;
  }
  catch (error) {
    logger.log({ error });
    state.is_loading = false;
  }
}

onMounted(async () => {
  await getActivities();
});
</script>

<template>
  <div class="mx-4">
    <HawkLoader v-if="state.is_loading" />
    <div v-else-if="state.activities.length" class="mb-2">
      <div v-for="activity in state.activities" :key="activity.uid" class="w-full border-b border-solid border-gray-200 text-sm text-gray-600 py-3">
        <div class="flex flex-col">
          <div class="flex items-center justify-between mb-2">
            <HawkMembers :members="activity?.actor?.split(':')?.[1]" type="badge" />

            <div class="text-xs text-gray-600 flex-shrink-0">
              {{ $date(props?.activity?.createdAt, 'Do MMMM YYYY') }}
            </div>
          </div>
          <ThermActivitiesItem :activity="activity" class="text-sm" is-detailed-view />
        </div>
      </div>
    </div>
    <HawkIllustrations v-else type="no-data" />
  </div>
</template>
